import React, { Component } from 'react';
import PropTypes from 'prop-types';
import loadingGif from './../../../globals/images/loading_big.gif';

class LoadingPage extends Component {
    render() {
        return (
            <div style={{ height: '100%', width: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                <img src={loadingGif} />
            </div>
        );
    }
}

LoadingPage.propTypes = {
}

LoadingPage.defaultProps = {
};

export default LoadingPage;



// WEBPACK FOOTER //
// /src/components/UiComponents/LoadingPage/LoadingPage.js